module.exports = __webpack_public_path__ + "img/petrobras.8e74eb32.png";